module.exports = __webpack_public_path__ + "media/images/facebook-af211bc185e2e1899a526bb3c632f130.svg";